import React from 'react';
import { useTranslation } from '../contexts/TranslationContext';
import { LANGUAGES } from '../utils/languages';

/**
 * Language dropdown component
 * Appears in top right corner
 */
function LanguageDropdown() {
  const { language, changeLanguage, t } = useTranslation();

  return (
    <div className="language-dropdown">
      <select
        value={language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="language-select"
        aria-label={t('selectLanguage')}
      >
        {LANGUAGES.map(lang => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default LanguageDropdown;

